<template>
  <v-row class="mx-0 mt-0 mb-4">
      <v-col>
          <Alert :message="error"
                 type="error"
                 v-if="showError"
                 @toggleAlert="showError = !showError" />

          <v-row>
              <v-col>
                  <div>
                      <v-flex xs12 class="instructionsInnerTitle caption text-center">
                          <span v-html="OTPDetails.otpDictionary.instructions"> </span>
                      </v-flex>
                  </div>
                  <SecondaryDisclaimer v-if="instructionSecondaryDisclaimerText">
                      <div v-html="instructionSecondaryDisclaimerText"
                           class="secondryDisc"></div>
                  </SecondaryDisclaimer>
              </v-col>
          </v-row>
          <v-row class="mt-2">
              <v-col>
                  <v-btn elevation="0"
                         block
                         class="mainButton redirectionBtn"
                         :class="startLoading"
                         :loading="loading"
                         :rounded="templateConfig.isButtonRounded"
                         @click="redirectToMerchantPage()">
                      <span v-html="instructionBtnText" v-if="!loading"></span>
                  </v-btn>
              </v-col>
          </v-row>
      </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { confirmPaymentMixin } from './confirmPaymentMixin.js';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';
import Alert from '../../Shared/components/Alert.vue';

export default {
  mixins: [confirmPaymentMixin],
  components: { SecondaryDisclaimer, Alert },
  computed: {
    ...mapState(['templateConfig', 'OTPDetails', 'merchantConfig']),
    instructionSecondaryDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.instructionSecondaryDisclaimer;
    },
    instructionBtnText() {
        //No need for $replacePlaceholders plugin function.
        return this.merchantConfig.texts.failureBtn; // TODO: create config in dashboard for instructions btn text

    },
  },
  methods: {
      ...mapMutations(['setOTPDetails']),
      redirectToMerchantPage() {
          this.loading = true;
          window.location.replace(this.instructionData.redirectUrl);
      },
  },
  data() {
    return {
      showSuccess: false,
      showError: false,
      loading: false,
      startLoading: '',
      error: '',
      success: '',
      showPendingMsg: false,
      API_Timeout: '',
      startingTime: 0,
      pinCode: '',
      loaded: false,
      instructionData: {}
    };
  },
  async activated() {
      let response = await this.$http.get(
          `/Payment/GetPaymentConfirmationResponse/otp?OperationStatusCode=pending`
      );
      this.instructionData = response.data;
  },
  mounted() {
    setTimeout(() => {
        this.startLoading = 'startLoading';
    }, 100);
    setTimeout(() => {
        this.redirectToMerchantPage();
    }, 6000);
    this.loaded = true
  }
};
</script>

<style scoped>
.instructionsInnerTitle {
  margin-top: 10px;
  font-size: 17px !important;
}
</style>
